/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
  Label,
} from 'react-bootstrap';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import Nvl from 'loracoms/Nvl';
import DatePicker from 'loracoms/DatePicker';
import PageSizer from 'loracoms/PageSizer';
import PanelToolbar from 'loracoms/PanelToolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const defaultFrom = () => startOfDay(subDays(new Date(), 7));
const defaultTo = () => endOfDay(new Date());
const kLimit = 10;

const propTypes = {
  intl: PropTypes.any.isRequired,
  deviceId: PropTypes.string.isRequired,
  deviceState: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  appState: PropTypes.object.isRequired,
  replaceState: PropTypes.func.isRequired,
};

class DeviceLogs extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      pageSize: kLimit,
      mark: 0,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.devicelog');
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.limit = kLimit;
    this.from = defaultFrom();
    this.to = defaultTo();
  }

  componentWillMount() {
    this.loadLogs();
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, appState } = nextProps;
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  loadLogs() {
    const { appId, deviceId } = this.props;
    callAPI({
      endpoint: `/lora/applications/${appId}/logs`,
      query: {
        order: 'desc',
        after: this.from.valueOf(),
        before: this.to.valueOf(),
        limit: this.limit,
        deveui: deviceId,
      },
    }).then((res) => {
      const { list, more } = res;
      this.setState({ list, more });
    }).catch(() => {});
  }

  handleChangePageSize(ps) {
    this.limit = ps;
    this.setState({ pageSize: ps });
    this.loadLogs();
  }

  handleChangeFrom(d) {
    const from = startOfDay(d);
    const to = endOfDay(d);
    this.setState({ from, to });
    this.from = from;
    this.to = to;
    this.loadLogs();
  }

  handleChangeTo(d) {
    const to = endOfDay(d);
    this.setState({ to });
    this.to = to;
    this.loadLogs();
  }

  renderToolbar() {
    const { pushState, appId, deviceId, replaceState } = this.props;
    const {
      deviceState: {
        data: { name } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderContent() {
    const { pushState } = this.props;
    const {
      list = [],
      appState: { data = {} },
      from = defaultFrom(),
      to = defaultTo(),
      pageSize,
    } = this.state;
    const fromPicker = <DatePicker date={from} onSelect={this.handleChangeFrom} />;
    const toPicker = (
      <DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => DeviceLogs.handleDisableDate(d, from)}
      />
    );

    const LogLevels = {
      error: <Label bsStyle="danger">ERROR</Label>,
      info: <Label bsStyle="info">INFO</Label>,
      warn: <Label bsStyle="warning">WARN</Label>,
      debug: <Label bsStyle="default">DEBUG</Label>,
    };
    const trs = list.map((l, idx) => {
      const info = l.info || {};
      const infos = _.map(Object.keys(info), k => (
        <span className={styles.parsed} key={k}>
          <span className={styles.key}>{k}</span>
          <span className={styles.value}>{info[k]}</span>
        </span>
      ));

      return (
        <tr key={String(idx)}>
          <td className={styles.loglevel}>{LogLevels[l.cat]}</td>
          <td>{format(l.$time, 'YYYY-MM-DD HH:mm:ss')}</td>
          <td>
            <RichLabel content={l.code} />
          </td>
          <td>
            <Link
              onClick={() => pushState(`/application/${data.id}/devices/${l.deveui}`)}
            >
              {normalizeDevEUI(l.deveui)}
            </Link>
          </td>
          <td>{infos}</td>
        </tr>
      );
    });

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('header')}>
        <PanelToolbar tools={[fromPicker, toPicker]} />
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th className={styles.loglevel}>
                {this.intlMsg.msg('thead.loglevel')}
              </th>
              <th> {this.intlMsg.msg('thead.time')} </th>
              <th> {this.intlMsg.msg('thead.code')} </th>
              <th>DevEUI</th>
              <th>{this.intlMsg.msg('thead.remark')} </th>
            </tr>
          </thead>
          <tbody>
            {trs}
          </tbody>
        </Table>
        <div className={`${styles.pager} clearfix`}>
          <PageSizer
            pageSize={pageSize}
            onChange={this.handleChangePageSize}
            options={[10, 20, 50, 100]}
          />
        </div>
      </Panel>
    );
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderContent()}
          </Col>
        </Row>
      </Grid>
    );
  }
}


DeviceLogs.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  deviceState: state.device.getDevice || {},
  appState: state.app.getApp || {},
  deviceId: ownProps.params.deviceId,
  appId: ownProps.params.appId,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(DeviceLogs));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceLogs/index.jsx